import BottomSheet from '@gorhom/bottom-sheet';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EarnStackParamList } from '@/features/earn';
import { getEarnCategoryTranslationKey } from '@/features/earn/utils/getEarnCategoryTranslationKey';
import { UserEarnOfferListResponseDataItem } from '@utx/utx-client';
import { BottomSheetFilterProps, BottomSheetFilterValues } from '../../bottomSheetFilter/BottomSheetFilter';

export const useDiscoverNative = ({ offers }: { offers: UserEarnOfferListResponseDataItem[] }) => {
  const earnNavigation = useNavigation<NativeStackNavigationProp<EarnStackParamList>>();
  const bottomSheetRef = useRef<BottomSheet>(null);
  const { t } = useTranslation('earn');

  const onClose = () => {
    earnNavigation.goBack();
  };

  const [filter, setFilter] = useState<BottomSheetFilterValues>({});
  const filterNumbers = Object.keys(filter)
    .map((key) => filter[key])
    .filter((item) => item).length;

  const bottomSheetFilterProps: BottomSheetFilterProps = {
    title: t('earn-invest::glossary.mobile-filter'),
    bottomSheetRef,
    options: [
      {
        label: t('earn-invest::glossary.mobile-filter-categories'),
        name: 'categories',
        options: offers.reduce((acc, offer) => {
          const category = offer.category;
          const label = t(getEarnCategoryTranslationKey(category));
          const value = category;
          const exists = acc.find((item) => item.value === value);
          if (!exists) {
            acc.push({ label, value });
          }
          return acc;
        }, [] as { label: string; value: string }[])
      }
    ],
    values: filter,
    filteringNumber: filterNumbers,
    onClose,
    onChange: (tempFilters) => {
      setFilter(tempFilters);
    }
  };

  const displayOffers = offers.filter((offer) => {
    if (!filter.categories) {
      return true;
    }
    return filter.categories.includes(offer.category);
  });

  return {
    bottomSheetRef,
    filter,
    bottomSheetFilterProps,
    displayOffers
  };
};
